import './assets/main.css'
import './index.css'

import * as Sentry from "@sentry/vue";

import { createApp } from 'vue'

import App from './App.vue'

const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://06b2a9429acae22bd21a5cc29110cdde@o4508993168080896.ingest.us.sentry.io/4508993204256768",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/triviagenerator\.com/],
  });

app.mount('#app')
